import LightModeIcon from '@mui/icons-material/LightMode';
import MenuIcon from '@mui/icons-material/Menu';
import NightlightIcon from '@mui/icons-material/Nightlight';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useAppThemeContext } from '../../contexts';
import LogoBalanco from './balanco-pronto.png';

const pages = [
  {
    url: '/#home',
    txt: 'Home',
  },
  {
    url: '/#quemsomos',
    txt: 'Quem Somos',
  },
  {
    url: '/#servicos',
    txt: 'Serviços',
  },
  {
    url: 'https://wa.me/5511989761201',
    txt: 'Contato',
  },
];

function ResponsiveAppBar() {
  const { toggleTheme, themeName } = useAppThemeContext();

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [estado, setEstado] = React.useState(Object);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (event: React.LinkHTMLAttributes<Event>) => {
    setAnchorElNav(null);
    setEstado(event);
  };

  return (
    <AppBar 
      position="static"
      sx={{
        backgroundColor:
          themeName === 'dark' ? '#000000' : '#253b59'
      }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{display: { xs: 'none', md: 'flex' }, mr: 2, flexGrow: 1}}><img src={LogoBalanco} height="80" width='181' alt="Logo Balanço Pronto" /></Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <a key={page.txt} href={page.url} target='blank' style={{textDecoration: 'none'}}>
                  <MenuItem onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">{page.txt}</Typography>
                  </MenuItem>
                </a>
              ))}
            </Menu>
          </Box>
          <Box sx={{display: { xs: 'flex', md: 'none' }, mr: 2, flexGrow: 1}}><img src={LogoBalanco} height="80" width='181' alt="Logo Balanço Pronto" /></Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              // eslint-disable-next-line react/jsx-key
              <a key={page.txt} href={page.url} target='blank' style={{textDecoration: 'none'}}>
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  {page.txt}
                </Button>
              </a>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            {themeName === 'light' && (<LightModeIcon onClick={toggleTheme} />)}
            {themeName === 'dark' && (<NightlightIcon onClick={toggleTheme} />)}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;